export const getEmployerCalendarEventsRoute = '/employer/calendar/upcoming-events/';
export const getApplicantCalendarEventsRoute = '/applicants/calendar/events/';
export const getEmployerCalendarEventsInterviewRoute = '/employer/calendar/get-block-interviews/';
export const getEmployerCalendarBlockRoute = '/employer/calendar/get-block-detail/';
export const createCalendarBlockRoute = '/employer/calendar/blocks/create/';
export const createCalendarBlockTimeRoute = '/employer/calendar/block/slots/';
// export const updateCalendarBlockRoute = '/employer/calendar/blocks/update/';
export const updateCalendarBlockRoute = '/employer/calendar/update-block/';
export const deleteCalendarBlockRoute = '/employer/calendar/blocks/delete/';
export const deleteInterviewRoute = '/employer/calendar/delete/';
export const updateInterviewRoute = '/employer/calendar/edit/';
export const getInterviewBlockSignUps = '/employer/calendar/blocks/signups/';
